module.exports = __webpack_public_path__ + "static/media/qrcode.80d3a15f.svg";